// Modules
import React from 'react'
import { Redirect, useHistory } from 'react-router-dom'

// Application
import { useApp, useSignUp } from 'context'
import { isEmpty } from 'utils'
import { useAnalytics } from 'hooks'
import { Analytics, ROUTES_PATH } from 'constants/index'

// Components
import { Header, TemplateContainer } from 'components'
import { Wrapper, ConfirmContact } from './components'

export const SNSelectContact: React.FC = () => {
    const history = useHistory()
    const { openToast } = useApp()
    const {
        hasSeenFirstStep,
        personalData,
        passwords,
        contact,
        phoneContacts,
        emailContacts,
        userId,
        setContactPhone,
        setContactEmail,
        setIsLoading,
        createLogin,
    } = useSignUp()

    const shouldRedirect =
        !personalData?.cpf || !personalData?.biologicalSex || !passwords?.password || isEmpty(userId) || !hasSeenFirstStep

    useAnalytics(Analytics.SignUp.SelectContactMount, !shouldRedirect)

    if (!phoneContacts || !contact || !emailContacts) {
        return null
    }

    const hasContacts = phoneContacts?.length + emailContacts?.length > 0

    if (shouldRedirect) {
        return <Redirect to={ROUTES_PATH.SIGN_UP_PERSONAL_DATA} />
    }

    if (hasContacts) {
        return (
            <TemplateContainer>
                <Header
                    subtitle="Escolha um desses contatos para receber o código de validação da sua conta Nav Dasa:"
                    title="Confirme que é você"
                />
                <Wrapper
                    biologicalSex={personalData?.biologicalSex}
                    contact={contact}
                    createLogin={createLogin}
                    emailContacts={emailContacts}
                    federalTaxId={personalData?.cpf}
                    history={history}
                    openToast={openToast}
                    password={passwords?.password}
                    phoneContacts={phoneContacts}
                    setContactEmail={setContactEmail}
                    setContactPhone={setContactPhone}
                    setIsLoading={setIsLoading}
                />
            </TemplateContainer>
        )
    }

    return <ConfirmContact />
}
